import React from 'react';
import './ErrorBoundary.css';

const ErrorPage: React.FC = () => (
  <div className='eb-screen'>
    <div className='eb-card'>
      <div className='eb-icon'>⚠️</div>
      <h2 className='eb-title'>Oups, quelque chose s'est mal passé</h2>
      <p className='eb-desc'>
        Une erreur inattendue s'est produite. Cela peut être causé par
        votre connexion ou une extension de navigateur.
      </p>
      <button className='eb-btn' onClick={() => window.location.reload()}>
        Recharger l'application
      </button>
    </div>
  </div>
);

export default ErrorPage;
